import type { ITableCell } from "../types";

// Mutually-exclusive cell shapes; precedence: calc → group → embedded → text.
export type CellKind = "text" | "group" | "embedded" | "calc";

export const getCellKind = (cell: ITableCell): CellKind => {
  if (cell.calculation) return "calc";
  if (cell.groupId != null || cell.group != null) return "group";
  if (cell.embedded != null) return "embedded";
  return "text";
};
